import { isArray } from "lodash";

import { EntityTypeName, isEntity } from "@ds/model/entity-model";

import { isPlainObject } from "@ds/utils/type-guards/common-guards";

export const createCampaignItemModel = (options?: Partial<CampaignItem>): CampaignItem => ({
  __typename: EntityTypeName.CONTENT_CAMPAIGN_ITEM,
  id: options?.id || 0,
  project_id: options?.project_id || 0,
  campaign_id: options?.campaign_id || 0,
  playlist_id: options?.playlist_id || 0,
  campaign_order: options?.campaign_order || 0,
  playlist_items_count: options?.playlist_items_count ?? 0,
  weight: options?.weight,
});

export const isCampaignItem = (obj: unknown): obj is CampaignItem =>
  isEntity(obj) && obj.__typename === EntityTypeName.CONTENT_CAMPAIGN_ITEM;

export const isApiCampaignItem = (obj: unknown): obj is ApiCampaignItem => isCampaignItem(obj) && "playlist" in obj;

export const isCampaignItemArray = (obj: unknown): obj is CampaignItem[] => isArray(obj) && obj.every(isCampaignItem);

export const isApiCampaignItemArray = (obj: unknown): obj is ApiCampaignItem[] =>
  isArray(obj) && obj.every(isApiCampaignItem);

export const isCampaignItemQueryOutput = (obj: unknown): obj is QueryOutput<CampaignItem> =>
  isPlainObject(obj) && "items" in obj && isCampaignItemArray(obj.items);

export const isApiCampaignItemQueryOutput = (obj: unknown): obj is QueryOutput<ApiCampaignItem> =>
  isPlainObject(obj) && "items" in obj && isApiCampaignItemArray(obj.items);
